
import { AI, AIGroup } from "@/lib/model/exam/result";
import { CandidateResult, Answer } from "@/lib/model/exam/result";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class AiGuide extends Vue {
  @Prop() all!: CandidateResult;
  @Prop() mindData!: Answer;
  @Prop({ type: String, default: "" }) showName!: string;
  showLogin = false;
  connectCode = "";
  positionMatchList = [
    {
      matchText: "不符合",
      notRecommendText: "候选人不能接受岗位基础要求，不推荐进入下⼀轮",
      recommendText: ""
    },
    {
      matchText: "低",
      notRecommendText: "候选人意愿与能力均较低，不推荐进⼊下⼀轮面试",
      recommendText: "候选人能能力达标但意愿较低，需要公司的额外努力争取"
    },
    {
      matchText: "中",
      notRecommendText: "候选人意愿⼀般，能力较低，不推荐进入下⼀轮",
      recommendText: "候选人意愿⼀般，能力达标，建议后续进⼀步考察求职意愿"
    },
    {
      matchText: "高",
      notRecommendText:
        "候选人意愿较高，但能力未达标，建议在后续环节考察发展潜力",
      recommendText: "候选人能力与意愿均较高，推荐进入下⼀轮"
    }
  ];

  // 是否存在辨色检测
  get isEyeColor(): boolean {
    return this.all.answerList.some(item => {
      return item.colorQuestionAnswerResult.type === 1;
    });
  }

  // 报告参考性-作答完整状态
  get candidateAnswerStatus() {
    // 存在未作答题目即是非完整作答
    const flag = this.all.answerList.find(res => {
      if ([6, 8].includes(+res.type)) {
        return (
          +res.isAnswered !== 1 || res.aliyunVideoId == "" || res.asr.length < 5
        );
      } else if (+res.type === 8) {
        return +res.isAnswered !== 1 || res.keys.length < 5;
      } else {
        return false;
      }
    });
    return flag ? `未完整作答` : "完整作答";
  }

  get dimensionReportGroup() {
    return this.all.dimensionReportGroup;
  }

  get configGroup() {
    return this.all.configGroup;
  }

  // 是否存在通用素质
  get isShowReadingGuidelinesType1() {
    let res = false;
    if (this.dimensionReportGroup.length) {
      this.dimensionReportGroup.forEach(group => {
        if (+group.readingGuidelinesType === 1) {
          res = true;
        }
      });
    }
    return res;
  }

  get dimensionList() {
    const dimensionList: AI[] = [];
    const groups = this.dimensionReportGroup.filter(group => {
      return +group.readingGuidelinesType === 1;
    });
    if (groups.length) {
      groups.forEach(group => {
        dimensionList.push(...group.dimensionList);
      });
    }
    return dimensionList;
  }

  // 进阶能力维度组
  get groupList() {
    const groupList: AIGroup[] = [];
    const groups = this.dimensionReportGroup.filter(group => {
      return +group.readingGuidelinesType === 4;
    });
    if (groups.length) {
      groups.forEach(group => {
        groupList.push(group);
      });
    }
    return groupList;
  }

  // 是否存在岗位匹配度解读
  get isShowReadingGuidelinesType2() {
    let res = false;
    if (this.dimensionReportGroup.length) {
      this.dimensionReportGroup.forEach(group => {
        if (+group.readingGuidelinesType === 2) {
          res = true;
        }
      });
    }
    return res;
  }

  // 是否存在职业规划解读
  get isShowReadingGuidelinesType3() {
    let res = false;
    if (this.dimensionReportGroup.length) {
      this.dimensionReportGroup.forEach(group => {
        if (+group.readingGuidelinesType === 3) {
          res = true;
        }
      });
    }
    return res;
  }

  // 是否存在进阶能力
  get isShowReadingGuidelinesType4() {
    let res = false;
    if (this.dimensionReportGroup.length) {
      this.dimensionReportGroup.forEach(group => {
        if (+group.readingGuidelinesType === 4) {
          res = true;
        }
      });
    }
    return res;
  }

  // 是否存在常模维度
  get hasNormData() {
    let res = false;
    if (this.dimensionReportGroup.length) {
      this.dimensionReportGroup.forEach(group => {
        if (+group.hasNormData === 1) {
          res = true;
        }
      });
    }
    return res;
  }
}
